<div class="filter-for-list">

    <app-level-crud [levelId]="null" [mode]="CRUD_MODE.create"></app-level-crud>


    <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
        <input matInput (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
    </mat-form-field>

    <mat-slide-toggle class="sliderActiveList" (change)="reLoadList()" ngModel="activeLevel" placement="right"
                      [ngbTooltip]="'LEVEL_ACTIVE_SLIDER_TOOLTIP' | translate">{{getActiveTextForSlider()}}
    </mat-slide-toggle>
    <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner===true"></app-progressbar>
<table mat-table [dataSource]="matTableDataSource" matSort class="table-striped" style="width:100%" matSortActive="id"
       matSortDirection="asc">

    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
        <td mat-cell *matCellDef="let level"> {{level.id}}</td>
    </ng-container>


    <ng-container matColumnDef="parent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PARENT_LEVEL'|translate}}</th>
        <td mat-cell *matCellDef="let level">
            <mat-chip-list *ngIf="level.parent !== undefined">
                <mat-chip matBadgePosition="below before" matBadgeColor="accent"
                          [matBadge]="level.parent.level">
                    {{level.parent.name}}
                </mat-chip>
            </mat-chip-list>

        </td>
    </ng-container>

    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME'|translate}}</th>
        <td mat-cell *matCellDef="let level">

            <mat-chip-list>
                <mat-chip class="selected" matBadgePosition="below after" matBadgeColor="primary"
                          [matBadge]="level.level">
                    {{level.name}}
                </mat-chip>
            </mat-chip-list>


        </td>
    </ng-container>

    <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'EMAIL'|translate}}</th>
        <td mat-cell *matCellDef="let level"> {{level.email}}</td>
    </ng-container>

    <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef>{{'ADDRESS'|translate}}</th>
        <td mat-cell *matCellDef="let level"> {{level.description?.place}} {{level.description?.street}}
            {{level.description?.zipcode}} {{level.description?.city}} {{level.description?.country}}
        </td>
    </ng-container>


    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef width="130px">{{'ACTIONS'|translate}}</th>
        <td mat-cell *matCellDef="let level">
            <div class="d-flex">
                <app-level-crud [levelId]="level.id" [mode]="CRUD_MODE.read"></app-level-crud>
                <app-level-crud [levelId]="level.id" [mode]="CRUD_MODE.update"></app-level-crud>
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>
<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="pageSize"></mat-paginator>



